import { z } from 'zod';

export const SyncJobTypeSchema = z.enum(['initial', 'scheduled_delta', 'manual_delta', 'manual_full']);
export type SyncJobType = z.infer<typeof SyncJobTypeSchema>;

export const SyncJobStatusSchema = z.enum(['queued', 'running', 'success', 'failed', 'partial']);
export type SyncJobStatus = z.infer<typeof SyncJobStatusSchema>;

export const SyncJobSchema = z.object({
  id: z.string(),
  organizationId: z.string(),
  provider: z.literal('uwm'),
  jobType: SyncJobTypeSchema,
  status: SyncJobStatusSchema,
  requestedByUserId: z.string().nullable().optional(),
  startedAt: z.string().datetime().nullable().optional(),
  completedAt: z.string().datetime().nullable().optional(),
  recordsFetched: z.number().int().nonnegative().default(0),
  recordsChanged: z.number().int().nonnegative().default(0),
  errorSummary: z.string().nullable().optional(),
  createdAt: z.string().datetime(),
});
export type SyncJob = z.infer<typeof SyncJobSchema>;

export const SyncStateSchema = z.object({
  organizationId: z.string(),
  provider: z.literal('uwm'),
  lastSuccessfulSyncAt: z.string().datetime().nullable().optional(),
  deltaCursor: z.string().datetime().nullable().optional(),
  fullSyncInProgress: z.boolean().default(false),
});
export type SyncState = z.infer<typeof SyncStateSchema>;
